import React, { useState } from 'react';
import PropertyForm from './PropertyForm';

const ListProperty = () => {
  const [showForm, setShowForm] = useState(true); // Auto-open form

  const handleFormSuccess = () => {
    // Refresh properties list or show success message
    console.log('Property added successfully!');
  };

  return (
    <div className="list-property-page">
      <div className="container">
        <div className="page-header">
          <h1>List Your Property</h1>
          <p>Join our platform and reach thousands of travelers worldwide</p>
        </div>

        <div className="property-benefits">
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">📈</div>
              <h3>Increase Bookings</h3>
              <p>Reach thousands of travelers and boost your occupancy rates</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">💰</div>
              <h3>Maximize Revenue</h3>
              <p>Set competitive prices and optimize your revenue potential</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🎯</div>
              <h3>Easy Management</h3>
              <p>Simple dashboard to manage bookings and property details</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">🛡️</div>
              <h3>Secure Payments</h3>
              <p>Safe and secure payment processing for all transactions</p>
            </div>
          </div>
        </div>

        <div className="property-actions">
          <button 
            className="btn btn-primary btn-large"
            onClick={() => setShowForm(true)}
          >
            Add Your Property
          </button>
          <p className="action-description">
            Fill out the form below to list your property on our platform
          </p>
        </div>

        {showForm && (
          <PropertyForm 
            onClose={() => setShowForm(false)}
            onSuccess={handleFormSuccess}
          />
        )}
      </div>
    </div>
  );
};

export default ListProperty;


